module.exports = __webpack_public_path__ + "img/global.79822a42.png";